import React from "react";
import { Avatar, List } from "antd";
import Typography from "antd/es/typography/Typography";

const { Title } = Typography;

const RecentInquiries = ({ recentInquiries }) => {
  if (!recentInquiries.length) {
    return <div className="dashboard-empty-state">No inquiries yet.</div>;
  }

  return (
    <div className="dashboard-panel">
      <div className="dashboard-panel__header">
        <div className="dashboard-panel__header-copy">
          <span className="dashboard-panel__eyebrow">Inbox</span>
          <Title level={5}>Recent Inquiries</Title>
          <span className="dashboard-panel__subtext">
            Scan the newest messages without leaving the dashboard.
          </span>
        </div>
        <span className="dashboard-panel__metric">{recentInquiries.length}</span>
      </div>
      <List
        itemLayout="horizontal"
        dataSource={recentInquiries}
        className="dashboard-panel__list"
        renderItem={(inquiry) => (
          <List.Item>
            <List.Item.Meta
              avatar={
                <Avatar
                  src={
                    inquiry.image
                      ? inquiry.image
                      : `https://xsgames.co/randomusers/avatar.php?g=pixel&key=${inquiry.id}`
                  }
                />
              }
              title={
                <a href={`/admin/contacts/${inquiry.id}`}>
                  {`${inquiry.name.toUpperCase()} - ${inquiry.subject}`}
                </a>
              }
              description={
                inquiry.comments || inquiry.message || "No comment provided"
              }
            />
          </List.Item>
        )}
      />
    </div>
  );
};

export default RecentInquiries;
